exports.default = undefined;
const { extend } = require('vee-validate');

// Install rules
_default = extend('nif', {
    validate(value) {
        const nif = value.split('');
        let check = 0;

        if (!/^[0-9]{9}$/.test(value)) return false;
        for (let i = 0; i < 8; i += 1) check += nif[i] * (10 - i - 1);
        check = 11 - (check % 11);
        if (check >= 10) check = 0;
        return check === parseInt(value.slice(-1), 10);
    },
});

exports.default = _default;
